import {defineStore} from 'pinia'
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {config} from "@/core/config";
import {SmartSearchConfig} from "@/main";
import {searchErrorLogger, searchLogger} from "@/core/Logger";
import {SanitizeValue} from "@/core/utils";


export const useSuggestionStore = defineStore('SuggestionStore', {
  state: () => {
    return {
      showSuggestions: false,
      suggestions: [],
      newSuggestions: [],
      typingTimer: 0,
      loading: false,
      suggestionsController: 0,
      useNewSuggestions: true,
      isMobileView: window.innerWidth <= 768,
      
    }
  },
  getters: {
    getSuggestions(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const suggestionsCount = SmartSearchConfig.value.autocomplete.suggestions.count
      return state.suggestions.slice(0, suggestionsCount)
    },
    getNewSuggestions(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const suggestionsCount = SmartSearchConfig.value.autocomplete.suggestions.count
      return state.newSuggestions.slice(0, suggestionsCount)
    }
  },
  actions: {
    async fetchSuggestions() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!SmartSearchConfig.value.autocomplete.suggestions.enabled) {
        searchLogger.log('Suggestions DISABLED');
        return [];
      }
      const queryStore = useSearchQueryStore();
      if (queryStore.searchQuery.length < 3) {
        return;
      }
      
      // if (this.suggestionsController) {
      //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //   // @ts-ignore
      //   this.suggestionsController.abort(); // Anulowanie poprzedniego żądania
      // }
      // // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // // @ts-ignore
      // this.suggestionsController = new AbortController();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // const {signal} = this.suggestionsController;
      
      const data = new FormData();
      const sanitizedQuery = SanitizeValue(queryStore.searchQuery)
      
      data.append('q', sanitizedQuery);
      
      try {
        this.loading = true;
        const response = await fetch(`https://${config.apiHost}/restapi/${config.customerSymbol}/search/${config.searchId}/suggestions`, {
          method: 'POST',
          headers: {
            'Api-key': config.apiKey,
          },
          body: data,
          credentials: 'include',
          // signal,
        });
        
        if (response.ok) {
          const data = await response.json();
          const {suggestions} = data;
          this.suggestions = suggestions;
          this.showSuggestions = true;
        }
      } catch (error) {
        searchErrorLogger.log('Error retrieving suggestions:', error);
      }
    },
    
    async fetchNewSuggestions() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!SmartSearchConfig.value.autocomplete.suggestions.enabled) {
        searchLogger.log('Suggestions DISABLED');
        return [];
      }
      const queryStore = useSearchQueryStore();
      if (queryStore.searchQuery.length < 3) {
        return;
      }
      //
      // if (this.suggestionsController) {
      //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //   // @ts-ignore
      //   this.suggestionsController.abort(); // Anulowanie poprzedniego żądania
      // }
      // // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // // @ts-ignore
      // this.suggestionsController = new AbortController();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // const {signal} = this.suggestionsController;
      
      const data = new FormData();
      const sanitizedQuery = SanitizeValue(queryStore.searchQuery)
      
      data.append('q', sanitizedQuery);
      
      try {
        this.loading = true;
        const response = await fetch(`https://${config.apiHost}/restapi/${config.customerSymbol}/search/${config.searchId}/suggestions`, {
          method: 'POST',
          headers: {
            'Api-key': config.apiKey,
          },
          body: data,
          credentials: 'include',
          // signal,
        });
        
        if (response.ok) {
          const data = await response.json();
          const {suggestions} = data;
          this.newSuggestions = suggestions;
          this.showSuggestions = true;
        }
      } catch (error) {
        searchErrorLogger.log('Error retrieving suggestions:', error);
      }
    }
  },
})